import script from "./TheSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./TheSelection.vue?vue&type=script&setup=true&lang=js"

import "./TheSelection.vue?vue&type=style&index=0&id=f3d78cd4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3d78cd4"]])

export default __exports__